import {
  ScmIntegrationsApi,
  scmIntegrationsApiRef,
  ScmAuth,
} from '@backstage/integration-react';

import {
  AnyApiFactory,
  configApiRef,
  createApiFactory,
  createApiRef,
  discoveryApiRef,
  alertApiRef,
  oauthRequestApiRef,
  OAuthApi,
  OpenIdConnectApi,
  ProfileInfoApi,
  BackstageIdentityApi,
  SessionApi,
} from '@backstage/core-plugin-api';

import { toastApiRef } from '@backstage/frontend-plugin-api';

import { OAuth2 } from '@backstage/core-app-api';

/**
 * Custom auth API ref for OIDC (Keycloak/Okta).
 * We'll use this in <SignInPage providers=[{ id:'oidc', apiRef: oidcAuthApiRef }]/>
 */
export const oidcAuthApiRef = createApiRef<
  OAuthApi &
    OpenIdConnectApi &
    ProfileInfoApi &
    BackstageIdentityApi &
    SessionApi
>({
  id: 'auth.oidc',
});

export const apis: AnyApiFactory[] = [
  createApiFactory({
    api: scmIntegrationsApiRef,
    deps: { configApi: configApiRef },
    factory: ({ configApi }) => ScmIntegrationsApi.fromConfig(configApi),
  }),

  createApiFactory({
    api: oidcAuthApiRef,
    deps: {
      discoveryApi: discoveryApiRef,
      oauthRequestApi: oauthRequestApiRef,
      configApi: configApiRef,
    },
    factory: ({ discoveryApi, oauthRequestApi, configApi }) =>
      OAuth2.create({
        discoveryApi,
        oauthRequestApi,
        provider: {
          id: 'oidc',
          title: 'OIDC',
        },
        environment:
          configApi.getOptionalString('auth.environment') ?? 'development',
        defaultScopes: ['openid', 'profile', 'email', 'offline_access'],
      }),
  }),

  createApiFactory({
    api: toastApiRef,
    deps: { alertApi: alertApiRef },
    factory: ({ alertApi }) => ({
      post(toast: any) {
        const message = typeof toast?.title === 'string' ? toast.title : '';
        let severity: 'warning' | 'error' | 'success' = 'success';
        if (toast?.status === 'warning') {
          severity = 'warning';
        } else if (toast?.status === 'danger') {
          severity = 'error';
        }
        alertApi.post({
          message,
          severity,
          display: 'transient',
        });
        return { close: () => {} };
      },
    }),
  }),

  ScmAuth.createDefaultApiFactory(),
];